import { Component, OnInit, OnDestroy, TemplateRef } from '@angular/core'
import { Globals } from '../globals'
import { Router, NavigationEnd } from '@angular/router'
import * as _ from 'underscore'
import * as __ from 'lodash'

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: false
})
export class ErrorComponent implements OnInit {
    error: { message: string; image: string } = { message: '', image: '' }

    constructor(public globals: Globals) {}

    ngOnInit() {
        if (__.isEmpty(this.globals.state)) {
            this.error.message = 'An error occurred, try again later. If you have any questions, please contact weski@wavestone.com.'
            this.error.image = '/assets/images/status-images/closed.png'
        } else {
            this.error.message =
                'The website is currently closed for maintenance, please come back later. If you have any questions, please contact weski@wavestone.com'
            this.error.image = '/assets/images/status-images/maintenance.png'
        }
    }
}
